module.exports = __webpack_public_path__ + "img/PSSS-M-3.ff5dd1dc.svg";